import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import PostsListing from './PostsListing/PostsListing'
import InnerTitleSection from 'components/InnerTitleSection/InnerTitleSection'
import { useCustomTranslation } from 'hooks/useCustomTranslation'
import Loader from 'components/Loader/Loader'

const Posts: React.FC = () => {
  const { t, i18n } = useCustomTranslation()
  const currentLanguage = i18n.language
  const isAr = currentLanguage === 'ar'

  const isLoading = useSelector((state: RootState) => state.posts.isLoading)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return isLoading ? (
    <Loader />
  ) : (
    <main>
      <InnerTitleSection
        title={t('navPosts')}
        breadcrumbs={[
          {
            title: t('navHome'),
            link: '/',
          },
          {
            title: t('navPosts'),
          },
        ]}
      />
      <PostsListing isAr={isAr} t={t} />
    </main>
  )
}

export default Posts
